<template><div><h1>VUX V2.0.0 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[change] 更新到 vue@2.0，使用 `v-model` 而不是`:show.sync`进行显示属性绑定</li>
<li>[feature] 添加属性 `close-on-clicking-mask`, 适用于强制选择的场景</li>
</ul>
<h2><a href="/zh-CN/components/alert.html">Alert</a></h2>
<ul><li>[change] 使用 `v-model` 而不是`:show.sync`进行显示属性绑定</li>
<li>[todo] 修复动画</li>
</ul>
<h2><a href="/zh-CN/components/button-tab.html">ButtonTab</a></h2>
<ul><li>[enhance] 去除 Android 下点击可能出现的蓝色边框</li>
</ul>
<h2><a href="/zh-CN/components/checker.html">Checker</a></h2>
<ul><li>[feature] 支持Object类型的值 #705</li>
</ul>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[change] 默认不显示错误，你可以监听on-error事件结合slot进行处理和显示</li>
<li>[feature] 添加插槽 footer、after-title</li>
<li>[change] 如果已经达到max上限，没有选中的选项将不能选择，因此不再和之前版本一样会出现最多可选max个的error信息</li>
<li>[change] 默认 required 值为false, 与html规范一致</li>
</ul>
<h2><a href="/zh-CN/components/color-picker.html">ColorPicker</a></h2>
<ul><li>[deprecated] 废弃，当前版本后不再继续维护</li>
</ul>
<h2><a href="/zh-CN/components/countdown.html">Countdown</a></h2>
<ul><li>[deprecated] 下一版本开始不再维护</li>
</ul>
<h2><a href="/zh-CN/components/countup.html">Countup</a></h2>
<ul><li>[feature] 添加 prop:`start`, 现在你可以手动开始计数了</li>
<li>[change] 更新依赖`countup`为`countup.js`</li>
</ul>
<h2><a href="/zh-CN/components/form-preview.html">FormPreview</a></h2>
<ul><li>[feature] 增加`form-preview`组件</li>
</ul>
<h2><a href="/zh-CN/components/load-more.html">LoadMore</a></h2>
<ul><li>[feature] 增加`load-more`组件</li>
</ul>
<h2><a href="/zh-CN/components/popover.html">Popover</a></h2>
<ul><li>[todo] 当切换i18n语言时，位置不正确</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[change] 使用 `v-model` 而不是`:show.sync`进行显示属性绑定</li>
<li>[change] 默认不显示遮罩</li>
<li>[feature] 添加 isShowMask 属性</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 添加 `novalidate` 及 `iconType` 可以禁用组件验证，手动显示 error 或者 success 样式</li>
<li>[feature] `is-type` 支持传入函数</li>
<li>[change] 受限于vue2不能动态设置type，目前`type`支持 text password number email</li>
</ul>
<h2><a href="/zh-CN/components/x-number.html">XNumber</a></h2>
<ul><li>[change] fillable 值默认为false, 稍微保护一下不小心商城的后端接口没有做好数据校验的用户，导致用户粘贴负数还提交正确</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.0.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.0.0-194.vue?73bf33fe